import React from 'react';

import { Icon } from '../../icon';
import { IconProps } from '../../icon/types';

export const TooltipInfoIcon = (props: IconProps) => (
  <Icon
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z"
      fill="#D8D8D8"
    />
    <path
      d="M11.9998 7.55566C11.3861 7.55566 10.8887 8.05313 10.8887 8.66678C10.8887 9.28042 11.3861 9.77789 11.9998 9.77789C12.6134 9.77789 13.1109 9.28042 13.1109 8.66678C13.1109 8.05313 12.6134 7.55566 11.9998 7.55566Z"
      fill="#808080"
    />
    <path d="M13.1109 16.4446V10.889H10.8887V16.4446H13.1109Z" fill="#808080" />
  </Icon>
);
